var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgelixir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 585",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1898,138)",
    d: "m0 0h22l20 3 24 8 17 9 12 9 11 9 8 8 12 16 10 18 6 15 5 19 3 23v10l-4 26-7 23-12 23-10 13-9 10-7 7-13 10-17 10-15 6-25 7-10 1h-22l-21-4-21-7-17-9-14-10-12-11-7-7-10-13-11-19-7-18-4-16-2-14v-28l3-19 8-24 11-21 11-14 9-10 10-9 11-8 14-8 16-7 19-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(177,142)",
    d: "m0 0h20l24 3 21 6 13 5 13 7 13 11 8 7 10 14 8 14 6 15 3 13 3 29v24l-1 10-75 1h-127l8 18 9 13 14 9 12 6 15 4 9 1h19l17-3 14-4 17-8 10-7 4 1 8 7 17 17 8 7 6 6-1 4-12 10-17 11-12 5-24 8-19 4-20 2h-14l-22-2-25-6-25-10-15-11-12-11-7-7-10-15-11-23-5-16-3-20v-29l3-20 6-18 8-16 9-15 13-15 11-9 18-12 22-8 16-4zm-2 58-16 4-16 9-10 7-10 16-5 9v2l2 1h134l-1-10-4-11-6-8-13-10-11-5-15-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1440,147)",
    d: "m0 0h10l18 2 18 5 11 4 18 10 13 10 10 9 9 11 9 13 11 23 6 21 2 15v12h-261l2-23 4-16 6-16 8-16 7-11 11-13 12-11 14-10 16-9 26-8z",
    fill: "#E74B7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1725,33)",
    d: "m0 0h13v47l-21 3-12 5-7 7-4 10-1 6-1 32 49-1 1 1v44l-1 1h-49v225l-1 1h-56l-1-13v-211l1-2h-32v-46h18l13 1 1-35 3-17 5-14 6-11 11-12 10-7 13-6 14-4 18-3z",
    fill: "#010101"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1190,142)",
    d: "m0 0h10l1 4-4 35-4 25-1 2-22 3-16 5-14 7-9 10-7 11-3 8-1 6-1 151-1 1h-74l-1-12v-183l1-65h69l2 5 2 14v7l3-1 7-8 10-9 16-8 11-4 17-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,46)",
    d: "m0 0h65v357l-1 1h-64l-1-5v-352z",
    fill: "#010202"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,148)",
    d: "m0 0h12l17 1v260l-1 1h-73v-261z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1519,287)",
    d: "m0 0h55l1 4-3 23-6 22-10 20-10 13-9 11-7 7-13 10-21 11-21 7-10 2-10 1h-19l-17-2-21-6-16-8-11-6-10-9-8-7-11-12-7-10-9-17-8-24-2-13-1-15 7-1 49 1 4 21 4 10 6 11 8 9v2l4 2 8 6 14 7 16 4h20l12-3 13-5 9-6 10-9 8-10 7-15 3-10z",
    fill: "#E74C7E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,149)",
    d: "m0 0h66v255h-66z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1906,213)",
    d: "m0 0h7l6 4 2 4 1 66 1 17 4 4 7 1 6-3 2-5v-73l2-8 6-4h11l6 5 1 2 1 35 1 71-2 18-5 13-7 9-8 8-8 4-10 2 1 36-2 1-10 1h-22l-6-1 1-36-8-1-11-4-10-9-7-12-4-14-1-6v-59l1-51 3-7 6-5 2-1h8l6 4 3 6 1 79 2 4 4 2h6l3-3 1-3 1-84 4-5z",
    fill: "#FBFCFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(695,283)",
    d: "m0 0h16l7 2v13l-4 27-5 18-7 16-9 17-11 12-8 7-14 7-15 4-14 1-16-2-11-3 1-5 6-12 11-24 9-25 5-18 7-11 11-10 10-5 19-7z",
    fill: "#67C3D0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,283)",
    d: "m0 0h13l15 3 16 6 13 7 10 10 5 8 8 27 11 28 9 19 5 7v4l-18 4-15 1-14-2-16-6-9-5-6-5-7-8-7-9-6-12-8-20-5-18-3-18-1-9v-9z",
    fill: "#DF325A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(814,146)",
    d: "m0 0h9l20 3 6 2-1 4-8 14-14 34-8 25-4 11-7 9-8 7-12 6-17 6-9 2-13 1-9-1-4-2-1-2 1-17 3-16 5-19 6-15 8-18 10-11 7-8 9-6 14-6z",
    fill: "#D14C94"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(630,146)",
    d: "m0 0 16 1 12 3 9 4 10 6 13 13 6 10 10 19 7 22 4 23 1 8v11l-5 3-12 1-15-2-13-4-16-7-9-7-7-7-6-11-4-16-8-22-13-29-5-10-1-4 16-4z",
    fill: "#2C7CBA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,39)",
    d: "m0 0h17l13 4 10 7 7 8 4 9 1 4v13l-4 10-6 9-8 7-12 5-4 1h-20l-14-5-10-9-6-7-4-11v-13l3-9 4-6 5-6 10-7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,42)",
    d: "m0 0h15l11 4 9 7 7 8 3 7 1 5v13l-3 10-7 9-8 7-8 4-6 1h-14l-9-2-10-7-7-8-5-10-1-4v-14l4-10 6-8 8-7 9-4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,149)",
    d: "m0 0h66v255h-61v-1h58l-1-250h-58v251h-4z",
    fill: "#1D1D1D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(316,245)",
    d: "m0 0h1l2 21v24l-1 10-75 1h-127l8 18 9 13 14 9 12 6 15 4 9 1h19l17-3 14-4 17-8 10-7 4 1 8 7 17 17 8 7 6 6-1 4-12 10-17 11-12 5-24 8-19 4h-8l3-3 5-1 11-1 27-9 22-11 10-7 7-5h2l-1-6-12-11-14-14-4-5-7-1-11 7-16 7-17 4-15 3h-13l-20-3-12-3-13-7v-2l-5-1v-2l-4-2-5-5-9-12-4-9-1-11 2-3 198-1 1-41z",
    fill: "#222A2B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(177,142)",
    d: "m0 0h20l24 3 21 6 13 5 13 7 13 11 8 7 10 14 8 14 6 15 3 13v7h-2l-2-5-1-10-11-23-10-16-7-9-7-6-12-9-4-2v-2l-4-1-10-5-20-7-10-2-3-1h-49l-4 2-16 3-21 8-14 8-12 9-3 1v2l-8 7-6 7-12 19-7 16-5 16-2 8v38l1 16 5 18 5 12 10 18 7 10 6 7 10 7 5 5 14 9 16 6 18 6 16 2 11 3 32 1v1l-12 1h-14l-22-2-25-6-25-10-15-11-12-11-7-7-10-15-11-23-5-16-3-20v-29l3-20 6-18 8-16 9-15 13-15 11-9 18-12 22-8 16-4z",
    fill: "#232A2B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1199,147)",
    d: "m0 0h1v10l-5 37-2 12-1 2-22 3-16 5-14 7-9 10-7 11-3 8-1 6-1 151-1 1h-74l-1-12v-183l1-65h69v1l-66 1v256l3-1 44 1 22 1-1-138 1-14 5-15 7-11 11-12 13-5 12-5 26-6 1-5 1-3 2-19 2-3v-18z",
    fill: "#2C3E41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(744,283)",
    d: "m0 0h13l15 3 16 6 13 7 10 10 5 8 8 27 11 28 9 19 5 7v4l-18 4-15 1-14-2-16-6-9-5-6-5-7-8-7-9-6-12-8-20-5-18-3-18-1-9v-9zm1 5-4 4-2 10 1 9 2 12 2 4 1 6h2l-1 3 3 6 1 4 5 13 5 10 8 9 7 8 4 4 15 9 11 3 9 1 5-1h6l7-1 5-2 2-3v-5l-4-5-3-6-2-8h-2v-5l-5-10-4-10-1-5-6-19-2-2-2-6-2-1-1-4-3-3-5-6-13-5-4-2h-4v-2l-11-3-1-1z",
    fill: "#E85A88"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,148)",
    d: "m0 0h12l17 1v260l-1 1h-73v-261zm16 4-58 1-1 1v252l2 3h68l-1-257z",
    fill: "#29383A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,46)",
    d: "m0 0h3v358h-3l-1-5v-352z",
    fill: "#3F484A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1790,471)",
    d: "m0 0h16l9 4 6 7 3 7v14l-5 10-7 6-4 2-13 1-8-2-8-6-5-9-1-5v-8l3-9 5-7 6-4zm7 6-9 3-5 6-1 3v14l4 7 8 5h9l6-3 5-6 1-2v-16l-4-6-6-4z",
    fill: "#202324"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1368,471)",
    d: "m0 0h16l9 4 6 7 3 8v13l-5 10-7 6-4 2-13 1-8-2-6-4-6-8-2-6v-11l3-9 6-7zm7 6-9 3-5 6-2 7v7l3 7 4 5 6 3h9l7-4 4-5 1-3v-15l-5-7-6-3z",
    fill: "#1F2323"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1738,468)",
    d: "m0 0h8v53h-8v-5l-7 5-11 1-7-3-6-8-2-6v-8l3-8 8-7 2-1h11l8 5v-17zm-14 20-7 3-3 5v11l4 6 3 2h9l5-4 2-3 1-9-3-6-5-4z",
    fill: "#1F2223"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1468,468)",
    d: "m0 0h8l1 1-1 52h-7l-2-4-6 4-10 1-6-2-5-5-4-7-1-9 3-9 5-6 6-3h10l9 5zm-14 20-8 4-2 5v9l4 6 3 3h9l6-5 2-5v-8l-4-6-7-3z",
    fill: "#1F2323"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(185,197)",
    d: "m0 0h2v2h24l16 5 11 7 10 10 7 14 1 6v10l-44 1h-35l-60-1-2-2 1-8 6-10 8-12 11-8 5-2v-2l12-5 10-3 15-1zm-10 3-16 4-16 9-10 7-10 16-5 9v2l2 1h134l-1-10-4-11-6-8-13-10-11-5-15-4z",
    fill: "#1E2020"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1443,106)",
    d: "m0 0 10 1 6 3 5 6 1 2v8l-4 6-3 3-10 3-9-1-6-4-4-5-1-2v-8l4-6 5-4z",
    fill: "#E74E7F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(316,245)",
    d: "m0 0h1l2 21v24l-1 10-75 1h-127l-1 2-1-3 2-3 198-1 1-41z",
    fill: "#303C3E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1975,481)",
    d: "m0 0h12l6 3 6 6 2 5v9l-1 1-29 1 3 5 4 3h8l7-5h7l-2 5-7 6-7 2h-7l-7-3-5-6-3-7v-9l4-9 7-6zm5 6-7 4-2 3v4h21l-1-5-5-5z",
    fill: "#1F2121"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1498,481)",
    d: "m0 0h12l7 4 6 8 1 4v7l-1 1h-30l3 6 4 3 6 1 7-4 2-2h7l-2 5-7 6-7 2h-7l-6-3-7-8-2-11 3-10 4-5zm5 6-7 4-3 4 1 3h21l-1-4-5-6z",
    fill: "#1F2223"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1199,147)",
    d: "m0 0h1v10l-5 37-2 12-1 2-22 3-16 5-14 7-9 10-7 11-3 8-1 6-1 151-3 1-1-139 1-14 5-15 7-11 11-12 13-5 12-5 26-6 1-5 1-3 2-19 2-3v-18z",
    fill: "#474F51"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1497,189)",
    d: "m0 0 9 3 10 7 10 10 9 14 6 14 3 12v11l-2 1h-10l-2-1-2-19-4-12-7-13-11-15-9-10z",
    fill: "#FDFDFD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1673,481)",
    d: "m0 0h12l8 4 6 8 1 4v8l-3 7-6 7-8 3h-7l-7-2-5-4-5-10v-9l3-7 4-5zm4 7-6 3-3 4-1 3v7l4 7 5 3h7l7-6 1-2v-11l-3-5-6-3z",
    fill: "#1F2323"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1627,481)",
    d: "m0 0h12l6 3 5 5 3 5 1 10-2 6-6 8-8 4h-9l-8-3-6-7-2-7 1-11 4-7 5-4zm3 7-6 4-2 3-1 8 3 8 6 4 9-1 5-5 1-3v-9l-3-5-3-3z",
    fill: "#1F2223"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,39)",
    d: "m0 0h17l13 4 10 7 7 8 4 9 1 4v13l-4 10-6 9-8 7-12 5-4 1h-20l-14-5-10-9-6-7-4-11v-13l3-9 4-6 5-6 10-7zm2 1-7 3-14 7-8 8-5 10-1 5v11l6 12 4 5 9 6 10 4 15 2 12-2 12-6 8-8 4-7 2-16-2-9-7-11-7-6-7-3-8-3-3-2z",
    fill: "#212728"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1936,480)",
    d: "m0 0 9 2 6 4 3 6v29h-8l-1-26-2-4-5-2-7 1-3 3-1 2-1 26h-8v-40l7 1 3 1z",
    fill: "#1E1F20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1833,481)",
    d: "m0 0 7 1v2l7-3h11l6 4 4 5 1 3v28h-8l-1-25-2-5-5-2-8 1-3 4-1 19v8h-8l-1-5v-33z",
    fill: "#202424"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1578,471)",
    d: "m0 0h28l2 1v5l-1 1h-20v14l17 1v5l-1 1-16 1v21h-8l-1-5z",
    fill: "#242D2E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,42)",
    d: "m0 0h15l11 4 9 7 7 8 3 7 1 5v13l-3 10-7 9-8 7-8 4-6 1h-14l-9-2-10-7-7-8-5-10-1-4v-14l4-10 6-8 8-7 9-4zm1 1-4 3-7 3-8 6-7 8-3 7v18l4 9 9 10 17 9h11l13-7 10-9 7-10 2-5v-10l-3-7-6-10-9-8-15-7z",
    fill: "#22292A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1879,468)",
    d: "m0 0h8l1 1v52h-8l-1-7z",
    fill: "#232B2D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(226,147)",
    d: "m0 0 10 2 17 6 15 8 13 11 8 7 10 14 8 14 6 15 3 13v7h-2l-2-5-1-10-11-23-10-16-7-9-7-6-12-9-4-2v-2l-4-1-10-5-20-7z",
    fill: "#222829"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1411,481)",
    d: "m0 0h6l2 5 7-5 5 1v6l-9 4-2 2-1 19v8h-8l-1-1v-38z",
    fill: "#1F2323"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1532,481)",
    d: "m0 0h7l2 5 7-5h4v7l-10 4-1 4-1 25h-8z",
    fill: "#1D1E1E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1899,481)",
    d: "m0 0h7l1 1v38l-1 1h-7z",
    fill: "#1D1D1D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1190,142)",
    d: "m0 0h10l1 4h-23l-5 2-12 3-12 5-11 7-10 9-9 9h-3v-12h1v7l3-1 7-8 10-9 16-8 11-4 17-3z",
    fill: "#232C2D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,42)",
    d: "m0 0 10 2 11 7 8 8 4 9 1 5v13l-3 10-7 9-8 7-8 4-7 1 1-3 12-6 10-9 7-11 1-3v-10l-3-7-6-10-8-7-15-7z",
    fill: "#232B2C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1336,488)",
    d: "m0 0h2v22l-22-9v-3l19-9z",
    fill: "#060707"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1199,147)",
    d: "m0 0h1v10l-5 37-2 12-1 2-22 3-17 5v-2l8-4 16-4 13-3 1-5 1-3 2-19 2-3v-18z",
    fill: "#262E2F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(206,199)",
    d: "m0 0 8 1 13 4 11 7 10 10 7 14v6l-2 2-3-12-7-11-13-10-11-5-15-4z",
    fill: "#232A2B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(177,142)",
    d: "m0 0h20l24 3 5 1v2h-8l-5-2h-51l1-2z",
    fill: "#2E4143"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1899,466)",
    d: "m0 0h8l1 4-2 6h-6l-2-1v-8z",
    fill: "#1E2021"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(185,197)",
    d: "m0 0h2v2h19v1l-31 1-13 3 2-4 4-1 15-1z",
    fill: "#232A2B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1190,142)",
    d: "m0 0h10l1 4h-26l1-2z",
    fill: "#2C3E41"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1199,147)",
    d: "m0 0h1v10l-2 17h-1l-1-6v-13z",
    fill: "#252F30"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(233,403)",
    d: "m0 0m-1 1m-3 1h3v2l-14 3h-8l3-3 5-1z",
    fill: "#202526"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,173)",
    d: "m0 0h1v8l-2 13-2 1v-13l2-7z",
    fill: "#212627"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1168,208)",
    d: "m0 0h6v2l-15 4-6 2v-2l8-4z",
    fill: "#232B2C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,409)",
    d: "m0 0 23 1v1l-12 1h-14l-5-1v-1z",
    fill: "#355357"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1113,151)",
    d: "m0 0 2 4 1 5v9l-3-3z",
    fill: "#252E30"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(185,197)",
    d: "m0 0h2v2h19v1h-25z",
    fill: "#1D1D1D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(213,145)",
    d: "m0 0h8l5 1v2h-8l-5-2z",
    fill: "#334548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgelixir);
export default __webpack_public_path__ + "static/media/svgelixir.4f036909ed20da59d1256d8d37fb888a.svg";
export { ForwardRef as ReactComponent };